<template>
  <v-dialog
    :model-value="dialog"
    :scrollable="scrollable"
    :persistent="persistent"
    :max-width="maxWidth"
    :fullscreen="fullscreen"
    :transition="false"
    :content-class="contentClass"
    :class="{
      'tunnl-modal--edge-fullscreen': fullscreen && !fullscreenBelowNav,
    }"
    @update:model-value="dialog = $event">
    <slot></slot>
  </v-dialog>
</template>

<script>
export default {
  name: "TunnlModal",
  props: {
    value: { type: Boolean, required: true },
    maxWidth: { type: [String, Number], default: "50vw" },
    fullscreen: { type: Boolean, default: false },
    fullscreenBelowNav: { type: Boolean, default: true },
    contentClass: { type: String, required: false, default: "" },
    persistent: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: true },
  },
  emits: ["close"],
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("close", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: calc(90% - 50px);
  z-index: 900;
}

.v-dialog--fullscreen {
  height: calc(100% - 90px);
  top: 90px;
}

.v-dialog--fullscreen.tunnl-modal--edge-fullscreen {
  height: 100dvh;
  max-height: 100dvh;
  top: 0;
}
</style>
